import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import IMAGES from 'shared/constants/images';

type Props = {
  /**
   * Show the success/fail message
   */
  success: boolean;
  /**
   * The success/fail messages to show.
   */
  message: {
    success?: string;
    fail?: string;
  };
};

/**
 * Show the result of a transaction.
 */
const SuccessFail = (props: Props) => {
  return (
    <View style={style.root}>
      <View style={{ flexGrow: 1, justifyContent: 'center' }}>
        <View style={{ alignItems: 'center' }}>
          <Image
            source={{
              uri: props.success ? IMAGES.success : IMAGES.exclamation,
            }}
            style={props.success ? style.imageSuccess : style.imageFailure}
          />
        </View>
        <View style={style.spacer} />
      </View>
      <Text style={[style.textTitle, style.textCenter]}>
        {props.success ? props.message.success : props.message.fail}
      </Text>
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
  },
  textTitle: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  textCenter: {
    textAlign: 'center',
  },
  spacer: {
    marginBottom: 24,
  },
  imageSuccess: {
    width: 256,
    height: 256,
  },
  imageFailure: {
    width: 100,
    height: 100,
  },
});

export default SuccessFail;
